import type { Components } from '@mui/material/styles';

export default function MUIButtonGroup(): Components['MuiButtonGroup'] {
  return {
    styleOverrides: {
      grouped: {
        minWidth: 0,
        flexShrink: 1,
      },
    },
  };
}
